import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";

import axios from 'util/axios';

import { useDispatch, useSelector } from "react-redux";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import update from "immutability-helper";

import { UnitRow, UnitRow2, DropBox, DropBox2 } from "./Rows";

import ModalPortal from "util/component/Modal";
import {Confirm, Modal} from "util/component/Modal/Modal";

import ModalPortal2 from "util/component/Modal2";
import { Modal2,Confirm2} from "util/component/Modal2/Modal";

import SearchableSelect from "util/component/SearchableSelect";

import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCopy, faCheck, faCancel, faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

import ReviewConfig from "./ReviewConfig";

import Preview from "../preview";
import EquisConfig from "./EquisConfig";

const Main = () => {
    const userInfo = useRef(null);
    const [Projects, SetProjects] = useState([]);
    const [Sheets, SetSheets] = useState([]);
    const [CheckOut, SetCheckOut] = useState(false);
    const [Sheets2, SetSheets2] = useState([]);
    const [SelProj, SetSelProj] = useState(null);

    const [equisData , setEquisData] = useState();

    const [ReviewerShow, SetReviewerShow] = useState(false);
    const [Equisshow, SetEquisshow] = useState(false);
    const [RevInfo, SetRevInfo] = useState(null);

    const [ModalShow, SetModalShow] = useState(false);
    const [ERRModal, SetERRModal] = useState(false);
    const [equisERRModal, setEquisERRModal] = useState(false);
    const [equisConfrim, setEquisConfrim] = useState(false);
    const [equisType, SetEquisType] = useState("equisY");
    const [successModal , setSuccessModal] = useState(false);


    const [ERRMsgData, SetERRMsgData] = useState({mbrNo: "", processCd: ""});
    const [equisERRMsgData, setEquisERRMsgData] = useState("");
    const HandleModalOpen = () => {
        SetModalShow((OLD) => !OLD);
    };
    const HandleERRModalOpen = () => {
        SetERRModal((OLD) => !OLD);
    };
    const HandleEquisERRModalOpen = () => {
        setEquisERRModal((OLD) => !OLD);
    };
    const HandleEquisConfrim = () => {
        setEquisConfrim((OLD) => !OLD);
    };
    const HandleSuccessModal = (boolean) => {
        setSuccessModal(boolean);
    };
    const isShiftDown = useRef(false);
    const isCtrlDown = useRef(false);

    const { t } = useTranslation(["page"]);

    const userSelector = useSelector((store) => store.user);
    const dispatch = useDispatch();

    const HandleReviewer = () => {
        window.scrollTo(0, 0);
        SetReviewerShow(true);
    };
    const HandleEquis = () => {
        window.scrollTo(0, 0);
        SetEquisshow(true);
    };

    const [PDFInfo, setPDFInfo] = useState(false);
    const [CanPDF, setCanPDF] = useState({ isInit: false, show: false });

    const getProjects = useCallback(async () => {
        dispatch({ type: "LOADING_ON" });

        const search = new URLSearchParams(window.location.search);
        userInfo.current = search.get("userInfo");

        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsGenerate/retrieveSheetByUserIdList",
            {
                userId: userSelector.userId,
                // userId: "sy2022.nam"
                // userId: "jiyeong0.kim",
                // userId: "heyn.lee",
                // userId: "haram.joo"
                // userId: "dg2023.lee"
            }
        );

        const data = response?.data.data.result;
        SetSelProj(null);
        SetProjects(data);
        SetSheets([]);
        SetSheets2([]);
        SetRevInfo(null);
        dispatch({ type: "LOADING_OFF" });
    }, [dispatch, userSelector.userId]);

    useEffect(() => {
        setCanPDF(OLD => {
            if (OLD.isInit) {
                return { isInit: false, show: true };
            } else {
                return { isInit: false, show: false }
            }
        });
    }, [Sheets])



    const getSheets = useCallback(
        async (url, setState) => {
            dispatch({ type: "LOADING_ON" });
            SetCheckOut(false)
            try {
                const response = await axios.post(process.env.REACT_APP_API + url, {
                    projectNm: Projects[SelProj]?.projectNm,
                    processCd: Projects[SelProj]?.processCd,
                });

                const data = response?.data.data.result;
                if (url.match("retrieveGenerateTemplateList")) {

                    const code = data[0]?.geneCode;


                    let response2 ;

                    if(code){
                        response2 = await axios
                            .post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewRound", { geneCode: code })
                            .catch((error) => console.error(error));
                    }


                    const reviewEnd = response2?.data.data.result?.reviewEnd;
                    SetRevInfo({
                        geneCode: code,
                        revision: response?.data.data.revision,
                        tempYn: response?.data.data.tempYn,
                        reviewEnd: reviewEnd,
                        userId: response2?.data.data.result?.userId,
                        userNm: response2?.data.data.result?.userNm
                    });

                    setCanPDF(OLD => { return { isInit: true, show: true } });
                }

                setState(data);
            } catch (e) {
                console.error(e);
            }

            dispatch({ type: "LOADING_OFF" });
        },
        [Projects, SelProj, dispatch]
    );

    useEffect(() => {
        const keyBindEventDown = (e) => {
            if (!(e.target?.tagName === "INPUT" || e.target?.tagName === "TEXTAREA")) {
                if (e.key?.toString().toUpperCase() === "SHIFT") {
                    isShiftDown.current = true;
                    document.getSelection().removeAllRanges();
                } else if (e.key?.toString().toUpperCase() === "CONTROL") {
                    isCtrlDown.current = true;
                }
            }
        };
        const keyBindEventUp = (e) => {
            isShiftDown.current = false;
            isCtrlDown.current = false;
        };
        getProjects();
        window.addEventListener("keydown", keyBindEventDown);
        window.addEventListener("keyup", keyBindEventUp);
        return () => {
            window.removeEventListener("keydown", keyBindEventDown);
            window.removeEventListener("keyup", keyBindEventUp);
        };
    }, [getProjects]);

    useEffect(() => {
        if (SelProj !== null && SelProj !== undefined) {
            getSheets("/pcsGenerate/retrieveGenerateTemplateList", SetSheets);
            getSheets("/pcsGenerate/retrieveDescriptionSheetAllList", SetSheets2);
        }
    }, [SelProj, getSheets, ReviewerShow]);

    let addTemplate = (item) => {
        SetSheets2((NS) => {
            let newNS = NS.slice();
            const idx = newNS.findIndex((t) => {
                return t === item;
            });
            newNS.splice(idx, 1);

            return newNS;
        });
        SetSheets((S) => {
            if (S.findIndex((f) => f.templateCode === item.sheetCode) < 0) {
                return [
                    ...S,
                    {
                        ...item,
                        templateNm: item.mbrNo,
                        templateCode: item.sheetCode,
                        templateRevision: item.revision,
                        templateType: "SHEET",
                        templateTemp: item.tempYn || "N",
                        maxRevision: item.revision,
                        maxTempYn: item.tempYn || "N",
                    },
                ];
            } else {
                return S;
            }
        });
    };

    const projRender = useMemo(() => {
        if (Projects.length > 0) {
            const proj = [...Projects];
            return proj.map((v, i) => {
                return (
                    <tr
                        className={"clickable text-center" + (SelProj === i ? " selected" : "")}
                        key={"proj_" + i}
                    >
                        <td onClick={() => {SetSelProj(i); SetEquisshow(false)}}>{v.projectNm}</td>
                        <td>{v.processCd}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="2" className={"text-center"}>
                        데이터가 없습니다
                    </td>
                </tr>
            );
        }
    }, [Projects, SelProj]);

    const sheetRender = useMemo(() => {
        if (!Sheets) return null;
        try {
            return Sheets?.map((v, i) => {
                if (v.templateType !== "DESC") {
                    return (
                        <UnitRow
                            callDetail={() => {
                                if (v.ownerId === userSelector.userId && v.templateTemp === "Y") {
                                    window.open("/mainForm?mid=" + v.templateCode + "&rev=" + v.templateRevision + "&tempYn=" + v.templateTemp)
                                } else {
                                    window.open("/detail?mid=" + v.templateCode + "&rev=" + v.templateRevision + "&tempYn=" + v.templateTemp)
                                }
                            }}
                            key={"sheets_" + i}
                            data={v}
                            index={i}
                            moveRow={(dragIndex, hoverIndex) => {
                                SetSheets((D) =>
                                    update(D, {
                                        $splice: [
                                            [dragIndex, 1],
                                            [hoverIndex, 0, D[dragIndex]],
                                        ],
                                    })
                                );
                                SetCheckOut(true)
                            }}
                            deleteRow={(e, index) => {
                                e.stopPropagation();
                                e.preventDefault();
                                SetSheets((D) =>
                                    update(D, {
                                        $splice: [[index, 1]],
                                    })
                                );
                                getSheets(
                                    "/pcsGenerate/retrieveDescriptionSheetAllList",
                                    SetSheets2
                                );
                            }}
                            changeRow={(selected) => {
                                SetSheets((S) =>
                                    update(S, {
                                        [i]: {
                                            $set: {
                                                ...S[i],
                                                templateRevision: parseInt(
                                                    selected.value.toString().replaceAll(/\D/g, "")
                                                ),
                                                templateTemp: selected.temp || "N",
                                            },
                                        },
                                    })
                                );
                            }}
                        />
                    );
                } else {
                    return null;
                }
            });
        } catch (e) {
            console.error(e.message);
            return null;
        }
    }, [Sheets, getSheets]);

    const HandleSheet2ClickMulti = () => {
        Sheets2.forEach((e) => {
            if (e.selected === true) {
                addTemplate(e);
            }
        });
    };
    const HandleSheet2ClickCancel = () => {
        SetSheets2((OLD) => OLD.map((e) => ({ ...e, selected: false })));
    };

    const handleSheet2ClickAll = () => {
        const checking = Sheets2.filter((f) => f.selected).length === Sheets2.length;
        SetSheets2((OLD) => OLD.map((e) => ({ ...e, selected: !checking })));
    };

    const renderMultipleMove = useMemo(() => {
        const isSelected = Sheets2.filter((f) => f.selected);
        if (isSelected.length > 0) {
            return (
                <div className="move_btn">
                    <div className="float-btn" style={{ marginTop: "35px" }}>
                        <button className="bpl-btn main" onClick={HandleSheet2ClickMulti}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                    <div className="float-btn" style={{ marginTop: "10px" }}>
                        <button className="bpl-btn danger" onClick={HandleSheet2ClickCancel}>
                            <FontAwesomeIcon icon={faCancel} />
                        </button>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }, [Sheets2]);

    const HandleSheet2Click = ({ target }) => {
        const index = target.closest("tr").dataset.index;

        SetSheets2((OLD) =>
            update(OLD, {
                [index]: {
                    $set: {
                        ...OLD[index],
                        selected: OLD[index].selected ? !OLD[index].selected : true,
                    },
                },
            })
        );
        // if (isCtrlDown.current) {
        //     SetSheets2((OLD) =>
        //         update(OLD, {
        //             [index]: {
        //                 $set: {
        //                     ...OLD[index],
        //                     selected: OLD[index].selected ? !OLD[index].selected : true,
        //                 },
        //             },
        //         })
        //     );
        // } else if (isShiftDown.current) {
        //     const isSelected = Sheets2.findIndex((f) => f.selected);
        //     if (isSelected < 0) {
        //         SetSheets2((OLD) =>
        //             update(OLD, {
        //                 [index]: {
        //                     $set: {
        //                         ...OLD[index],
        //                         selected: OLD[index].selected ? !OLD[index].selected : true,
        //                     },
        //                 },
        //             })
        //         );
        //     } else {
        //         if (isSelected < index) {
        //             for (let i = isSelected; i <= index; i++) {
        //                 SetSheets2((OLD) =>
        //                     update(OLD, {
        //                         [i]: {
        //                             $set: {
        //                                 ...OLD[i],
        //                                 selected: true,
        //                             },
        //                         },
        //                     })
        //                 );
        //             }
        //         } else {
        //             for (let i = index; i <= isSelected; i++) {
        //                 SetSheets2((OLD) =>
        //                     update(OLD, {
        //                         [i]: {
        //                             $set: {
        //                                 ...OLD[i],
        //                                 selected: true,
        //                             },
        //                         },
        //                     })
        //                 );
        //             }
        //         }
        //     }
        // } else {
        //     addTemplate(Sheets2[index]);
        // }
    };

    const sheetRender2 = useMemo(() => {
        try {
            if (Sheets2?.length > 0) {
                const filter = Sheets?.filter((f) => f.templateType === "SHEET");
                return Sheets2.map((v, i) => {
                    const find = filter.find((f) => f.templateCode === v.sheetCode);

                    if (!find) {
                        return (
                            <UnitRow2
                                key={"sheets2_" + i}
                                data={v}
                                index={i}
                                onClick={HandleSheet2Click}
                            />
                        );
                    } else return null;
                });
            } else {
                return null;
            }
        } catch (e) {
            console.error(e.message);
            return null;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Sheets2, Sheets]);

    const HandleDSRevChange = useCallback(
        (selected) => {
            const newSheets = Sheets.map((f) => {
                if (f.templateType === "DESC") {
                    return {
                        ...f,
                        templateRevision: selected.value.toString().replaceAll(/\D/g, ""),
                        templateTemp: selected.temp || "N",
                    };
                } else {
                    return { ...f };
                }
            });
            SetSheets(newSheets);
        },
        [Sheets]
    );

    const SelectRender = useMemo(() => {
        let tempRow;
        let tempValue;
        try {
            tempRow = Sheets?.find((f) => f.templateType === "DESC");
            tempValue = tempRow?.templateRevision + (tempRow?.templateTemp === "Y" ? "T" : "");
            const options = new Array(tempRow?.maxRevision).fill().map((e, i) => {
                return { label: i + 1, value: i + 1 };
            });

            if (tempRow.maxTempYn === "Y") {
                options.push({
                    label: tempRow.maxRevision,
                    value: tempRow.maxRevision + "T",
                    temp: "Y",
                });
            }
            let isWarn = "";
            if (tempRow?.maxTempYn === "Y") {
                if (tempRow?.templateTemp !== "Y") isWarn = "low-revision-warn";
            } else {
                if (tempRow?.maxRevision > tempRow?.templateRevision) isWarn = "low-revision-warn";
            }
            return (
                <td
                    className={isWarn}
                    style={{
                        textAlign: "center",
                        overflow: "initial",
                    }}
                >
                    <SearchableSelect
                        options={options}
                        value={tempValue}
                        placeholder={""}
                        onChange={HandleDSRevChange}
                        revision={true}
                    />
                </td>
            );
        } catch (e) {
            return (
                <td
                    className={
                        tempRow?.maxRevision > tempRow?.templateRevision ? "low-revision-warn" : ""
                    }
                    style={{
                        textAlign: "center",
                        overflow: "initial",
                    }}
                ></td>
            );
        }
    }, [Sheets]);

    // Legacy const docDataRef = useRef();

    const previewFunc = () => {
        const { revision, tempYn, selected } = RevInfo;

        const ds = Sheets.find((f) => f.templateType === "DESC");
        const sheets = Sheets.filter((f) => f.templateType === "SHEET");
        const sheetList = sheets.map((s) => {
            return {
                sheetCode: s.templateCode,
                revision: s.templateRevision,
                tempYn: s.templateTemp || "N",
            };
        });

        const revInfo = {
            revision: selected ? selected.value : revision.maxRevision,
            tempYn: selected ? 'N' : tempYn,
            ...Projects[SelProj]
        }

        const DS_DATA = {
            descCode: ds.templateCode,
            revision: ds.templateRevision,
            tempYn: ds.templateTemp || "N",
            sheetList: sheetList,
            userId: userSelector?.userId,
            revInfo: revInfo
        };

        const BASE64_ENCODED = btoa(JSON.stringify(DS_DATA));
        window.open("/PCSGeneratorPreview?data=" + encodeURIComponent(BASE64_ENCODED), "_blank");
    };

    const PDFDownFunction = async () => {
        const uri = '/pcsGenerate/retrieveGenerateTemplateForSave';
        const { geneCode, revision, tempYn, selected } = RevInfo;
        const postData = {
            "geneCode": geneCode,
            revision: selected ? selected.value : revision.maxRevision,
            tempYn: selected ? 'N' : tempYn,
            ...Projects[SelProj]
        }
        const response = await axios.post(process.env.REACT_APP_API + uri, postData);
        const data = response.data.data;

        setPDFInfo({ ...data, revInfo: postData });
    }
    const EQUIS = async () => {
        dispatch({ type: "LOADING_ON" });
        const uri = '/veeva/retrieveEquisDocInfo';
        const { geneCode, revision, tempYn, selected } = RevInfo;
        const postData = {
            geneCode: geneCode,
            revision: selected ? selected.value : revision.maxRevision,
            tempYn: selected ? 'N' : tempYn,
            userId :  userSelector.userId,
            ...Projects[SelProj]
        }
          axios.post(process.env.REACT_APP_API + uri, postData)
               .then((res) =>{
                   if(res.data.data.result === "SUCCESS"){

                        if(res.data.data.data.id){
                            SetEquisType("equisY")
                            setEquisData(res.data.data.data);
                            HandleEquis();
                        }else{
                            equisDocList(postData);
                        }

                   }else{
                       const value={docNo:""}
                       setEquisERRMsgData(t(res.data.data.result,{value}))
                       HandleEquisERRModalOpen();
                   }
                   dispatch({ type: "LOADING_OFF" });
               });

    }

    const equisDocList =(postData) =>{
        SetEquisshow(false);
        axios.post(process.env.REACT_APP_API + "/veeva/retrieveEquisDocList", postData)
            .then((res)=>{
                setEquisData(res.data.data.data);
            })
        HandleEquisConfrim();
    }
    const PDFFunction = (data) => {
        setPDFInfo(false);
    }

    const createPostData = (temp) => {
        const data = [...Sheets];
        const dsData = data?.find((f) => f.templateType === "DESC");
        const shData = data?.filter((f) => f.templateType === "SHEET");
        const postData = {};
        postData.projectNm = dsData.projectNm;
        postData.processCd = dsData.processCd;
        postData.revision = (RevInfo.revision?.maxRevision || 0) + (temp ? 1 : 0);
        postData.userId = userSelector.userId;
        postData.geneCode = dsData.geneCode || null;
        postData.sheetList = [];
        const dsDataForPostData = {
            templateType: "DESC",
            templateCode: dsData.templateCode,
            templateRevision: parseInt(dsData.templateRevision.toString().replaceAll(/\D/g, "")),
            templateTemp: dsData.templateTemp || "N",
        };
        // postData.sheetList.push()
        postData.sheetList.push({
            templateSeq: 1,
            ...dsDataForPostData,
            templateNm: "DESCRIPTION HEADER",
        });
        postData.sheetList.push({
            templateSeq: 2,
            ...dsDataForPostData,
            templateNm: "DESCRIPTION COMMON",
        });

        shData.forEach((e, i) => {
            postData.sheetList.push({
                templateSeq: i + 1 + 2,
                templateType: "SHEET",
                templateCode: e.templateCode,
                templateRevision: e.templateRevision,
                templateTemp: e.templateTemp,
                templateNm: e.templateNm,
            });
        });
        postData.sheetList.push({
            templateSeq: shData.length + 1 + 2,
            ...dsDataForPostData,
            templateNm: "DESCRIPTION FOOTER",
        });

        return postData;
    };

    const saveDocGen = async (e) => {
        e.target.blur();
        const postData = createPostData(true);
        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsGenerate/createGenerateTemplate",
            postData
        );

        SetCheckOut(false)

        if (response?.data.data.result === 1) {
            await getSheets("/pcsGenerate/retrieveGenerateTemplateList", SetSheets);
            await getSheets("/pcsGenerate/retrieveDescriptionSheetAllList", SetSheets2);
            HandleModalOpen();
        } else if(response?.data.data.result === "ERR109"){
            let mbrNo = "";
            let processCd = "";
            Sheets?.forEach((data) =>{
                if(data.sheetCode === response?.data.data.sheetCode){
                    mbrNo =  data.mbrNo;
                    processCd = data.processCd;
                }
            })
            SetERRMsgData({mbrNo : mbrNo,processCd : processCd});
            HandleERRModalOpen();
        }else{
            window.alert("Error");
            console.error(response);
        }
    };

    const saveDocGenTemp = async (e) => {
        e.target.blur()
        const postData = createPostData(false);
        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsGenerate/createGenerateTemplateTemp",
            postData
        );

        SetCheckOut(false)

        if (response?.data.data.result === 1) {
            await getSheets("/pcsGenerate/retrieveGenerateTemplateList", SetSheets);
            await getSheets("/pcsGenerate/retrieveDescriptionSheetAllList", SetSheets2);
            HandleModalOpen();
        } else if(response?.data.data.result === "ERR109"){
            let mbrNo = "";
            let processCd = "";
            Sheets?.forEach((data) =>{
                if(data.sheetCode === response?.data.data.sheetCode){
                    mbrNo =  data.mbrNo;
                    processCd = data.processCd;
                }
            })
            SetERRMsgData({mbrNo : mbrNo,processCd : processCd});
            HandleERRModalOpen();
        }else{
            window.alert("Error");
            console.error(response);
        }
    };

    const getSheetsByGeneCode = async (geneCode, revision, tempYn) => {
        dispatch({ type: "LOADING_ON" });
        if (tempYn === "Y") {
            await getSheets("/pcsGenerate/retrieveGenerateTemplateList", SetSheets);
        } else {
            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsGenerate/retrieveGenerateTemplateListByRevision",
                {
                    geneCode,
                    revision,
                }
            );

            const result = response?.data.data.result;
            SetSheets(result);
        }
        dispatch({ type: "LOADING_OFF" });
        setCanPDF(OLD => { return { isInit: true, show: true } });
    };

    const RevChange = (selected) => {
        const revision = selected.value.toString().replaceAll(/\D/g, "");
        const code = Sheets.find((f) => f.templateType === "DESC").geneCode;
        SetRevInfo((OLD) => ({ ...OLD, selected: selected }));
        getSheetsByGeneCode(code, revision, selected.temp || "N");
    };

    const RevisionSelector = useMemo(() => {
        if (RevInfo?.revision && RevInfo?.tempYn) {
            const options = [];
            for (let i = 0; i < RevInfo.revision.maxRevision; i++) {
                options.push({ label: i + 1, value: i + 1 });
            }

            const tempYn = RevInfo.tempYn;
            let value;
            if (tempYn !== "N") {
                value = RevInfo.selected || RevInfo.revision.maxRevision + "T";
                options.push({
                    label: RevInfo.revision.maxRevision,
                    value: RevInfo.revision.maxRevision + "T",
                    temp: "Y",
                });
            } else {
                value = RevInfo.selected || RevInfo.revision.maxRevision;
            }
            return (
                <SearchableSelect
                    search={false}
                    border={"ON"}
                    options={options}
                    value={value}
                    height={"33px"}
                    onChange={RevChange}
                    revision={true}
                />
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [RevInfo]);

    const RenderBtns = useMemo(() => {
        try {
            const { geneCode, revision, selected, tempYn, reviewEnd, userId, userNm } = RevInfo;
            const isTempExist = Sheets.filter((f) => f.templateTemp === "Y");
            const sheetLen = Sheets.filter((f) => f.templateType !== "DESC");

            const maxRev = revision?.maxRevision;
            const curRev = selected?.value.toString().replace("T", "");


            let canSave = false;
            let canReview = tempYn === "Y" && sheetLen.length > 0;
            let firstTemp ;
            if (geneCode && sheetLen.length > 0) {
                if (isTempExist.length < 1) {
                    if (!selected) {
                        canSave = true;
                        firstTemp = maxRev === 0 && tempYn === "Y";
                    } else {
                        const revChk = maxRev + (tempYn === "Y" ? 1 : 0);
                        const curRev2 = (curRev * 1) + (selected?.temp === "Y" ? 1 : 0);
                        canReview = curRev2 === revChk && selected.temp === "Y";
                        canSave = curRev2 >= revChk;
                        firstTemp = revChk === 1 && tempYn === "Y";
                    }
                }
            }
            let canRev2 = false;
            if (reviewEnd === 'N') {
                if (userId !== userSelector.userId) {
                    canRev2 = true;
                }
            }

            if(CheckOut) canReview = false;

            if (SelProj !== null && Sheets.toString() !== "ERR104") {
                return (
                    <div className="button-box">
                        <div style={{width: "100px", height: "40px"}}>{RevisionSelector}</div>
                        {canReview && (
                            <button className={"bpl-btn primary reviewing-now"} onClick={HandleReviewer}
                                    disabled={canRev2}
                            >
                                {t("sendForReview")}
                                {RevInfo?.reviewEnd === 'N' &&
                                    <div className={"reviewing-now"}>{t("nowReviewing")}</div>}
                                {canRev2 &&
                                    <div className={"reviewing-permission"}>{t("nopermission")}<br/>Owner: {userNm}
                                    </div>}
                            </button>

                        )}
                        {(firstTemp !== undefined && !firstTemp) && CanPDF.show && !canReview && geneCode &&
                            <button className={"bpl-btn success"} onClick={EQUIS} disabled={ReviewerShow}>
                                {t("EQUIS")}
                            </button>
                        }
                        <button className={"bpl-btn success"} onClick={previewFunc} disabled={ReviewerShow}>
                            {t("preview")}
                        </button>
                        {
                            CanPDF.show &&
                            <button className={"bpl-btn success"} onClick={PDFDownFunction} disabled={ReviewerShow}>
                                PDF Download
                            </button>
                        }

                        <button className={"bpl-btn main tempSaveBtn"} onClick={saveDocGenTemp}
                                disabled={RevInfo?.reviewEnd === 'N' || ReviewerShow}
                        >
                            {t("newTempSave")}
                        </button>
                        <button
                            className={"bpl-btn main"}
                            onClick={saveDocGen}
                            disabled={(!canSave || RevInfo?.reviewEnd === 'N') || ReviewerShow}
                        >
                            {t("save")}
                        </button>
                    </div>
                );
            } else return null;
        } catch (e) {
            return null;
        }
    }, [SelProj, Sheets, RevInfo, CanPDF]);


    return (
        <section className={"doc-gen"} style={ReviewerShow ? {overflow: "hidden"} : {}}>
            <h3 className="title">PCS Generator</h3>
            <div className="main-container">
                <div className="left">
                    <h5 className={"section-title"}>Owning Project List</h5>
                    <table className="bpl-table-default proj-table">
                        <colgroup></colgroup>
                        <thead>
                            <tr>
                                <th>Project</th>
                                <th>Process</th>
                            </tr>
                        </thead>
                        <tbody>{projRender}</tbody>
                    </table>
                </div>
                <div className="right">{RenderBtns}</div>
                <div className={"content-area"}>
                    {Sheets.toString() === "ERR104" && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            {t(Sheets)}
                        </div>
                    )}
                    {
                        (SelProj !== null &&
                            SelProj !== undefined) && (
                            <>
                                <DndProvider backend={HTML5Backend}>
                                    <>
                                        <div className="left">

                                            {SelProj !== null &&
                                                SelProj !== undefined &&
                                                Sheets.toString() !== "ERR104" && (
                                                    <><h5 className={"section-title"}>Unselected MBR</h5>
                                                        <DropBox2>
                                                            <table className="bpl-table-default compact-row fixed gen-table">
                                                                <colgroup>
                                                                    <col width="30px" />
                                                                    <col width="80px" />
                                                                    <col width="80px" />
                                                                    <col width="80px" />
                                                                    <col />
                                                                    <col width="80px" />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr>
                                                                        <th
                                                                            onClick={handleSheet2ClickAll}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {Sheets2.filter((f) => f.selected)
                                                                                .length === Sheets2.length &&
                                                                                Sheets2.length > 0 && (
                                                                                    <FontAwesomeIcon
                                                                                        icon={faCheck}
                                                                                    />
                                                                                )}
                                                                        </th>
                                                                        <th>Project</th>
                                                                        <th>MBR No.</th>
                                                                        <th>Process</th>
                                                                        <th>Desc.</th>
                                                                        <th>Rev.</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>{sheetRender2}</tbody>
                                                            </table>
                                                        </DropBox2>
                                                    </>
                                                )}
                                        </div>
                                        {renderMultipleMove}
                                        <div className={"right"}>

                                            {Sheets.toString() !== "ERR104" && (
                                                <>
                                                    <h5 className={"section-title"}>Selected MBR</h5>
                                                    <DropBox addRow={addTemplate} states={Sheets2}>
                                                        <table className="bpl-table-default compact-row fixed sheet-table">
                                                            <colgroup>
                                                                <col width="80px" />
                                                                <col width="80px" />
                                                                <col width="80px" />
                                                                <col />
                                                                <col width="80px" />
                                                                <col width="30px" />
                                                                <col width="35px" />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>Project</th>
                                                                    <th>MBR No.</th>
                                                                    <th>Process</th>
                                                                    <th>Desc.</th>
                                                                    <th>Rev.</th>
                                                                    <th></th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan="4">Description Header</td>

                                                                    {SelectRender}

                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="4">Description Common</td>

                                                                    {SelectRender}

                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                {sheetRender}
                                                                <tr>
                                                                    <td colSpan="4">Description Footer</td>

                                                                    {SelectRender}

                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </DropBox>
                                                </>
                                            )}

                                        </div>
                                    </>
                                </DndProvider>
                            </>
                        )
                    }

                </div>
            </div>
            {ModalShow && (
                <ModalPortal>
                    <Modal onClose={HandleModalOpen}>{t("saved")}</Modal>
                </ModalPortal>
            )}
            {ERRModal && (
                <ModalPortal>
                    <Modal onClose={HandleERRModalOpen}>{t("ERR109")} <br/>
                        <div style={{textAlign:"center"}} >
                            MBR No : {ERRMsgData.mbrNo} / Process : {ERRMsgData.processCd}
                        </div>
                    </Modal>
                </ModalPortal>
            )}
            {equisERRModal && (
                <ModalPortal2>
                    <Modal2 onClose={HandleEquisERRModalOpen}>{equisERRMsgData}
                    </Modal2>
                </ModalPortal2>
            )}
            {equisConfrim &&
                <ModalPortal2>
                    <Confirm2
                        //EQUIS
                        onConfirm={HandleEquis}
                        onClose={HandleEquisConfrim}
                    >
                        <p >Is this document available in EQUIS?</p>
                        <br/>
                        <div style={{textAlign:"left"}}>
                            <input type={'radio'} name={"equisYN"} id={"equisY"} onChange={(e)=> SetEquisType(e.target.id) } checked={equisType === "equisY"}
                            />
                            <label htmlFor="equisY"> YES, already exist in EQUIS: Revise PCS in EQUIS</label>
                        </div>
                        <div style={{marginTop:"3px",textAlign:"left"}}>
                            <input type={'radio'} name={"equisYN"} id={"equisN"} onChange={(e)=> SetEquisType(e.target.id) } checked={equisType === "equisN"}
                            />
                            <label htmlFor="equisN"> No, New PCS: Create new PCS in EQUIS</label>
                        </div>
                    </Confirm2>
                </ModalPortal2>
            }
            {successModal && (
                <ModalPortal2>
                    <Modal2 onClose={()=>HandleSuccessModal(false)}>successfully created
                    </Modal2>
                </ModalPortal2>
            )}
            {Equisshow && <EquisConfig SetEquisshow={SetEquisshow} equisData={equisData} project={Projects[SelProj]}
                                       RevInfo={RevInfo} equisType={equisType} equisDocList={equisDocList} HandleSuccessModal ={HandleSuccessModal}/>}
            {ReviewerShow && <ReviewConfig onClose={SetReviewerShow} revInfo={RevInfo} project={Projects[SelProj]}/>}
            {PDFInfo && (<div style={{display: "none", position: "fixed", top: 0, left: 0, zIndex: 100, backgroundColor: "#FFF", width: "100%", height: "100%", overflow: "auto" }}>

                <Preview docData={PDFInfo} func={PDFFunction} />
            </div>)}

        </section>
    );
};

export default Main;
